import type { R2BAvailableBrandEntity } from "../../entity_types/r2bAvailableBrand";

export const r2b_available_w1: R2BAvailableBrandEntity = {
  token: "r2b_available_w1",
  type: "r2bAvailableBrand",
  name: "Woon",
  stagingBrandToken: "r2b_staging_woon",
  benefits: [
    {
      text: "Free Shipping with Insider",
      color: "teal",
    },
    {
      text: "Exclusivity available",
      color: "default",
    },
  ],
  newBadgeIndexes: [0, 1],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
